import React from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import styled, { css } from 'styled-components';

import customTheme from 'app/style/theme';

import { Heading, Text, Box } from 'grommet';
import MenuPane from 'app/components/Menu/MenuPane';

const StyledText = styled(Text)`
  font-style: italic;
  :hover {
    color: ${customTheme.global.colors['neutral-2']};
    text-decoration: underline;
  }
`;

const BookmarkEntry = styled(Box)`
  :hover {
    cursor: pointer;
  }
  ${props =>
    props.highlight &&
    css`
      background: ${customTheme.global.colors.focus};
    `};
`;

// credits: https://stackoverflow.com/questions/9450733/css-triangle-custom-border-color
const Note = styled(Box)`
  position: relative;
  /* forms the triangle */
  :after {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
  }
  /* controls triangle fill color */
  :after {
    bottom: -20px;
    left: 12px;
    border-color: ${customTheme.global.colors['light-1']} transparent
      transparent transparent;
    border-width: 10px;
  }
`;

function removeMarkup(sentence){

  const contextPattern = /\$\{([^}]+)\}\{([^}]+)\}/;
  const hasMarkup = sentence.match(contextPattern);
  if (!hasMarkup) return sentence;

  const [context, anchor] = hasMarkup;
  const front = sentence.substring(0, hasMarkup.index);
  const back = removeMarkup(
    sentence.substring(hasMarkup.index + context.length)
  );
  return (
    <React.Fragment>
      {front}
      {anchor}
      {back}
    </React.Fragment>
  );
}

function Bookmarks({ AppState }) {
  if (!AppState.isBookmarksMenuOpen) return null;
  return (
    <MenuPane aria-label="bookmark menu">
      <Heading responsive textAlign="center" margin="small" size="small">
        Bookmarks
      </Heading>
      {_.map(AppState.bookmarks.groupedEntries, (selections, entry) => (
        <React.Fragment key={entry}>
          <Heading responsive level={3} size="small" margin="xsmall">
            {entry}
          </Heading>
          {_.map(selections, (selection, index) => {
            return (
              <BookmarkEntry
                highlight={_.isEqual(selection.path, AppState.bookmarkToDelete.slice())}
                key={entry + index}
                pad={{ vertical: 'small' }}
                border={
                  _.isEqual(index, _.size(selections) - 1)
                    ? undefined
                    : 'bottom'
                }
                onClick={() => {
                  if (AppState.isUserDeleting) {
                    AppState.prepareToDeleteBookmark(selection.path);
                  } else {
                    AppState.toggleBookmarksMenu();
                    AppState.changeSectionItem(selection.path);
                  }
                }}
              >
                {selection.note && (
                  <Note
                    round="xsmall"
                    background="light-1"
                    margin={{ vertical: 'small' }}
                  >
                    <Text margin={{ left: 'small' }} size="medium">
                      {selection.note}
                    </Text>
                  </Note>
                )}
                <StyledText truncate>{removeMarkup(selection.content)}</StyledText>
              </BookmarkEntry>
            );
          })}
        </React.Fragment>
      ))}
    </MenuPane>
  );
}

export default inject('AppState')(observer(Bookmarks));



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Bookmarks.js